import StringScript from "./StringScript";

export default StringScript;